import { render, staticRenderFns } from "./StudentWarnV2.vue?vue&type=template&id=c632c6c6&scoped=true"
import script from "./StudentWarnV2.vue?vue&type=script&lang=js"
export * from "./StudentWarnV2.vue?vue&type=script&lang=js"
import style0 from "./StudentWarnV2.vue?vue&type=style&index=0&id=c632c6c6&scoped=true&lang=css"
import style1 from "./StudentWarnV2.vue?vue&type=style&index=1&id=c632c6c6&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c632c6c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c632c6c6')) {
      api.createRecord('c632c6c6', component.options)
    } else {
      api.reload('c632c6c6', component.options)
    }
    module.hot.accept("./StudentWarnV2.vue?vue&type=template&id=c632c6c6&scoped=true", function () {
      api.rerender('c632c6c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/StudentWarnV2.vue"
export default component.exports